import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import Button from "../../components/form/Button";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/logo.png";
import icon from "../../assets/images/fav.png";
import { useTranslation } from "react-i18next";
import { rgba, toSnakeCase } from "../../helpers";
import { Coffee } from "lucide-react";

const AdminSideBar = ({ isMenuOpen, setMenuOpen = () => {}, isHeaderExpanded = false }) => {
  const { t } = useTranslation();
  const { session } = useSelector((state) => state?.authProvider);
  const message = useSelector((state) => state?.message);
  const { data } = useSelector((state) => state?.profile);
  const { appliedTheme, selectedElement, status } = useSelector((state) => state?.themeProvider);

  const adminSidebarMenu = [
    {
      _id: "dashboard",
      menuTitle: "Dashboard",
      menuData: [
        {
          _id: "dashboard",
          menuLabel: "Dashboard",
          menuLink: "/admin/dashboard",
          menuIcon: "fa-regular fa-grid-2",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-table-columns",
    },
    {
      _id: "Media",
      menuTitle: "Media",
      menuData: [
        {
          _id: "media",
          menuLabel: "List",
          menuLink: "/admin/media",
          menuIcon: "fa-regular fa-photo-film-music",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-photo-film-music",
    },
    {
      _id: "users",
      menuTitle: "Users",
      menuData: [
        {
          _id: "users",
          menuLabel: "User",
          menuLink: "/admin/users/user",
          menuIcon: "fa-regular fa-user",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-users-gear",
    },
    {
      _id: "menu",
      menuTitle: "Menu",
      menuData: [
        {
          _id: "menu",
          menuLabel: "List",
          menuLink: "/admin/menu",
          menuIcon: "fa-solid fa-book-open",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-solid fa-book-open",
    },
    {
      _id: "category",
      menuTitle: "Menu Category",
      menuData: [
        {
          _id: "menu-category",
          menuLabel: "Categories",
          menuLink: "/admin/menu-categories",
          menuIcon: "fa-regular fa-layer-group",
          menuIconColor: "text-primary",
        },
        
      ],
      mainMenuIcon: "fa-regular fa-layer-group",
    },
    {
      _id: "table",
      menuTitle: "Table",
      menuData: [
        {
          _id: "table",
          menuLabel: "Table",
          menuLink: `/admin/table`,
          menuIcon: "fa-solid fa-chair",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-solid fa-utensils",
    },
    {
      _id: "order",
      menuTitle: "Orders",
      menuData: [
        {
          _id: "order",
          menuLabel: "Orders",
          menuLink: `/admin/order`,
          menuIcon: "fa-solid fa-utensils",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-solid fa-receipt",
    },
    {
      _id: "email",
      menuTitle: "Email",
      menuData: [
        {
          _id: "email",
          menuLabel: "Email",
          menuLink: `/admin/email-template`,
          menuIcon: "fa-solid fa-envelope-open",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-solid fa-envelope-open",
    },
    {
      _id: "transactions",
      menuTitle: "Transactions",
      menuData: [
        {
          _id: "transaction",
          menuLabel: "Transactions",
          menuLink: `/admin/transaction`,
          menuIcon: "fa-solid fa-money-bill-wave",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-solid fa-money-bill-wave",
    },
    
  ];

  const [expandedMenuId, setExpandedMenuId] = useState(null);

  const handleToggle = (id) => {
    setExpandedMenuId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    // if (adminSidebarMenu.length > 0) {
    //   setExpandedMenuId(adminSidebarMenu[0]._id);
    // }
    const firstExpandableMenu = adminSidebarMenu.find((item) => item.menuData?.length > 1);
    if (firstExpandableMenu) {
      setExpandedMenuId(firstExpandableMenu._id);
    }
  }, []);

  return (
    <div className="relative w-full">
      <div
        className={`relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700` + (isMenuOpen ? "px-3" : "px-3")}
        {...(appliedTheme?.customiseLogo?.backgroundColor && {
          style: {
            backgroundColor: "rgba(appliedTheme?.customiseLogo?.backgroundColor)",
          },
        })}
      >
        <Link className="h-12  mx-auto " to={"/"} replace>
          <img
            className="w-[100px] h-[100px] object-contain"
            src={appliedTheme?.logo instanceof File ? URL.createObjectURL(appliedTheme?.logo) : appliedTheme?.logo?.url || appliedTheme?.logo}
            alt={"Logo"}
          />
        </Link>
      </div>
      <div
        className={`relative overflow-auto scroll-smooth scrollbar scrollbar-1 transition-all duration-200 px-1 mt-[60px] ${
          isHeaderExpanded ? "max-h-[calc(100vh-26rem)]" : "max-h-[calc(100vh-16rem)]"
        }`}
      >
        {Array.isArray(adminSidebarMenu) &&
          adminSidebarMenu?.map((item, index) => {
            if (item) {
              return (
                <SidebarMenuBlocks
                  key={item._id}
                  menuTitle={item.menuTitle}
                  menuData={item.menuData}
                  mainMenuIcon={item?.mainMenuIcon}
                  isMenuOpen={isMenuOpen}
                  isExpanded={expandedMenuId === item._id}
                  onToggle={() => setExpandedMenuId((prev) => (prev === item._id ? null : item._id))}
                />
              );
            }
            return null;
          })}
      </div>
    </div>
  );
};

export default AdminSideBar;
